<template>
  <v-container>
    <v-row>
      <Tabs
        :tabs="tabs"
        :level="2"
        :tab-lv1-index="tabLv1Index"
        :tabs-lv1-count="tabsLv1Count"
      />
    </v-row>
  </v-container>
</template>

<script>
import Tabs from '../../../components/Reporting/Tabs';
import ChairUtilization from './ChairUtilization';
import Collections from './Collections';
import Patients from './Patients';
import Production from './Production';
import Treatments from './Treatments';

export default {
  name: 'DDSReporting',
  components: {
    Tabs,
    ChairUtilization,
    Collections,
    Patients,
    Production,
    Treatments,
  },
  props: ['tabLv1Index', 'tabsLv1Count'],
  data() {
    return {
      pageName: 'DDS Reports',
      tabs: [
        { label: 'Collections', section: Collections },
        { label: 'Production', section: Production },
        { label: 'Treatments', section: Treatments },
        { label: 'Patients', section: Patients },
        { label: 'Chair Utilization', section: ChairUtilization },
      ],
    };
  },
};
</script>
